import React from "react";

const DisabledButton = () => {
  return (
    <button disabled type="button" class="btn btn-secondary">
      Loading Please wait...
    </button>
  );
};

export default DisabledButton;
